import { render, staticRenderFns } from "./clicktoedit.vue?vue&type=template&id=571d1016&scoped=true&lang=pug"
import script from "./clicktoedit.vue?vue&type=script&lang=js"
export * from "./clicktoedit.vue?vue&type=script&lang=js"
import style0 from "./clicktoedit.vue?vue&type=style&index=0&id=571d1016&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571d1016",
  null
  
)

export default component.exports